import React, { useCallback } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';

import {
  orderedSuperBatchModulesSelector,
  setSuperBatchModules,
  updateMenteeModuleOrder,
} from 'features/moduleManagement';

function SuperBatchModulesDragDrop({ children, orderedCoreMenteeModules }) {
  const dispatch = useDispatch();
  const orderedSuperBatchModules = useSelector(
    orderedSuperBatchModulesSelector
  );

  const handleDragEnd = useCallback(
    (result) => {
      if (!result.destination) {
        return;
      }

      if (result.destination.index === result.source.index) {
        return;
      }

      const sourceSuperBatchModule =
        orderedCoreMenteeModules[result.source.index];
      const destSuperBatchModule =
        orderedCoreMenteeModules[result.destination.index];

      if (String(sourceSuperBatchModule.id) !== result.draggableId) {
        return;
      }
      if (!destSuperBatchModule) {
        return;
      }

      // Reusing the already built mentee module hook
      const updatedCoreMenteeModules = updateMenteeModuleOrder({
        menteeModules: orderedCoreMenteeModules,
        menteeModuleId: sourceSuperBatchModule.id,
        newOrder: destSuperBatchModule.order,
      });
      const updatedSuperBatchModules = orderedSuperBatchModules.map(
        (superBatchModule) => {
          const coreMenteeModule = updatedCoreMenteeModules.find(
            (sbm) => sbm.id === superBatchModule.id
          );
          return coreMenteeModule ?? superBatchModule;
        }
      );

      dispatch(setSuperBatchModules(updatedSuperBatchModules));
    },
    [dispatch, orderedCoreMenteeModules, orderedSuperBatchModules]
  );

  return (
    <DragDropContext onDragEnd={handleDragEnd}>{children}</DragDropContext>
  );
}

export default SuperBatchModulesDragDrop;
